/*
 * @Author: Assistant
 * @Date: 2024-12-19
 * @Description: Browser polyfills for compatibility
 */

// requestIdleCallback polyfill for Safari and iOS Chrome
export const initRequestIdleCallbackPolyfill = () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.requestIdleCallback === 'undefined'
  ) {
    window.requestIdleCallback = function (callback: IdleRequestCallback) {
      const start = Date.now();
      return window.setTimeout(() => {
        callback({
          didTimeout: false,
          timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
        });
      }, 1) as unknown as number;
    };

    window.cancelIdleCallback = function (id: number) {
      window.clearTimeout(id);
    };
  }
};
